import { toggle } from "./toggle";

export default toggle("manifest-enabled");
